import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useNavigate, useParams } from "react-router-dom";

import "./CameraView.css";
import {
  CameraView as CameraViewWidget,
  CameraViews,
  SetCamerasModelDTO,
  useIsMobileDetect,
  videoService,
} from "@shared/ui";
import { Rnd } from "react-rnd";

const CameraViewOnly: React.FC<{ isViewOnly: boolean }> = ({ isViewOnly }) => {
  const { t } = useTranslation();
  const [view, setView] = useState(1);
  const { droneId } = useParams();
  const [disconnect, setDisconnect] = useState(false);
  const [cameras, setCameras] = useState<SetCamerasModelDTO[]>([]);
  const navigate = useNavigate();

  const isMobilePortrait = useIsMobileDetect();

  useEffect(() => {
    if (droneId) {
      videoService
        .getCameras(droneId)
        .then((data) => {
          setCameras(data);
        })
        .catch();
    }
  }, [droneId]);

  /*const droneConnected = async (data: string[]) => {
        setCameras(data);
    };*/

  const endSession = async () => {
    navigate("/dashboard");
  };

  return (
    <div className={!isViewOnly ? "wrapper controls" : "wrapper no-controls"}>
      <div className="switch-view-camera">
        {cameras.length > 0 ? (
          <button
            onClick={() => setView(1)}
            className={view === 1 ? "camera-view1 active" : "camera-view1"}
          >
            View 1
          </button>
        ) : null}
        {cameras.length >= 2 ? (
          <button
            onClick={() => setView(2)}
            className={view === 2 ? "camera-view2 active" : "camera-view2"}
          >
            View 2
          </button>
        ) : null}
        {cameras.length >= 2 ? (
          <button
            onClick={() => setView(3)}
            className={view === 3 ? "camera-view3 active" : "camera-view3"}
          >
            View 4
          </button>
        ) : null}
      </div>
      {droneId && cameras.length ? (
        <CameraViews
          cameras={cameras}
          view={view}
          droneId={droneId!}
          disconnect={disconnect}
          isViewOnly={isViewOnly}
        />
      ) : null}

      <div className="view-only-exit">
        <button onClick={endSession} className="btn exit-camera-view">
          {t("cameraView.exitButton")}
        </button>
      </div>

      {!isMobilePortrait && view === 1 && cameras.length > 1 && (
        <Rnd
          default={{
            x: 0,
            y: window.innerHeight - 55 - 168,
            width: 300,
            height: 168,
          }}
          style={{
            zIndex: "110000"
          }}
        >
          <div className="small-camera-view">
            <CameraViewWidget
              camera={cameras[1]}
              droneId={droneId!}
              disconnect={disconnect}
              smallView={true}
            />
          </div>
        </Rnd>
      )}

      <div
        className="rotate-overlay"
        aria-live="polite"
        role="dialog"
        aria-modal="true"
      >
        <div className="rotate-card">
          <svg className="rotate-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7 7h10a2 2 0 0 1 2 2v5.5a.5.5 0 0 1-1 0V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6.5a.5.5 0 0 1 0 1H7a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z" />
            <path d="M20.5 15a.5.5 0 0 1 .5.5 6.5 6.5 0 1 1-11.09-4.61.5.5 0 0 1 .68.73A5.5 5.5 0 1 0 21 15.5a.5.5 0 0 1-.5.5H18a.5.5 0 0 1 0-1h2.5z" />
          </svg>
          <p className="rotate-title">{t("cameraView.rotateTitle")}</p>
          <p className="rotate-text">{t("cameraView.rotateText")}</p>
        </div>
      </div>

      {/*{droneId && <DroneControlPanel onDroneConnected={droneConnected} droneId={droneId} cameraView={view} isViewOnly={isViewOnly}/>}*/}
    </div>
  );
};
export default CameraViewOnly;
